import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { useWorkspaceContext } from 'hooks/common/useWorkspaceContext';
import { fetchWrapper } from 'utils/fetchWrapper';
import { generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { BoardAttributes, SingleBoardResponse } from 'types/Boards';

type MutationVariables = Omit<Partial<BoardAttributes>, 'workspaceID'>;

export function useAddBoards() {
  const queryClient = useQueryClient();
  const { currentWorkspaceID } = useWorkspaceContext();

  const addBoard = (variables: MutationVariables = {}) => {
    if (!currentWorkspaceID) {
      return Promise.reject('Workspace ID cannot be null');
    }

    const url = generateURL(SPARK_RESOURCE_TYPES.BOARDS);

    const body = {
      data: {
        type: SPARK_RESOURCE_TYPES.BOARDS,
        attributes: {
          ...variables,
          workspaceID: currentWorkspaceID,
        },
      },
    };

    return fetchWrapper<SingleBoardResponse>({
      url: url,
      method: 'POST',
      body: body,
    });
  };

  return useMutation(['addBoard', currentWorkspaceID], addBoard, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`Failed to Add Board: ${error.message}`);
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries([
        SPARK_RESOURCE_TYPES.BOARDS,
        currentWorkspaceID,
      ]);
    },
  });
}
